/**
 * SSOT-45 / #10169 — client-side name shape for OIG adverse checks.
 * Mirrors Rules `validate_adverse_check_name`.
 */

export function isValidAdverseCheckName(
  value: string | null | undefined,
): boolean {
  const s = String(value ?? "").trim();
  if (s.length < 2) return false;
  if (/^\d+$/.test(s)) return false;
  return /[A-Za-z]/.test(s);
}
